/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UserInfoDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class UserService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 사용자를 탈퇴 처리합니다.
   *
   * @tags UserService
   * @name WithdrawUser
   * @summary Withdraw User
   * @request PUT:/v1/users/{id}/withdraw
   * @secure
   */
  withdrawUser = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/${id}/withdraw`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Manually verifies and approves a user’s membership.
   *
   * @tags UserService
   * @name ApproveUser
   * @summary Approve user verification
   * @request PUT:/v1/users/{id}/verify
   * @secure
   */
  approveUser = (id: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/users/${id}/verify`,
      method: 'PUT',
      secure: true,
      ...params,
    });
  /**
   * @description 사용자의 탈퇴를 해제합니다.
   *
   * @tags UserService
   * @name UnwithdrawUser
   * @summary Unwithdraw User
   * @request PUT:/v1/users/{id}/unwithdraw
   * @secure
   */
  unwithdrawUser = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/${id}/unwithdraw`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserService
   * @name SetAdminRole
   * @summary Set User as Admin
   * @request PUT:/v1/users/{id}/admin
   * @secure
   */
  setAdminRole = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/${id}/admin`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserService
   * @name UnsetAdminRole
   * @summary Unset User as Admin
   * @request DELETE:/v1/users/{id}/admin
   * @secure
   */
  unsetAdminRole = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/${id}/admin`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserService
   * @name GetUsers
   * @summary Get Users
   * @request GET:/v1/users
   * @secure
   */
  getUsers = (
    query?: {
      isAdmin?: boolean;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["signupDate,DESC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserInfoDto[], any>({
      path: `/v1/users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserService
   * @name GetUser
   * @summary Get User by ID
   * @request GET:/v1/users/{id}
   * @secure
   */
  getUser = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
